import React, { useState } from 'react';
import Select from 'components/shared/Select';

interface PolicyFormData {
  expireIn: string;
  enforcePasswordHistory: string;
  minimumPasswordLength: string;
  passwordComplexity: string;
  maxInvalidLoginAttempts: string;
  lockoutEffectivePeriod: string;
  cancelSubscriptionAfter: string;
}

const Policies: React.FC = () => {
  const [formData, setFormData] = useState<PolicyFormData>({
    expireIn: '6 months',
    enforcePasswordHistory: '2 passwords remembered',
    minimumPasswordLength: '10',
    passwordComplexity: 'Include special characters, alphabets, numbers',
    maxInvalidLoginAttempts: '3',
    lockoutEffectivePeriod: '3',
    cancelSubscriptionAfter: '3 times'
  });

  const handleInputChange = (field: keyof PolicyFormData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <div className="mt-10">
      <form onSubmit={handleSubmit}>
        {/* Password Policies Section */}
        <div className="mb-5">
          <h2 className="text-lg font-semibold text-white mb-5">Password policies</h2>
          <div className="space-y-6 bg-[#2A2A2A] rounded-lg p-6">
            <div className="flex items-start gap-8">
              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Expire in</label>
                <Select
                  value={formData.expireIn}
                  onChange={(value) => handleInputChange('expireIn', value)}
                  options={['3 months', '6 months', '12 months']}
                  className="w-full mt-2"
                />
              </div>

              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Enforce password history</label>
                <Select
                  value={formData.enforcePasswordHistory}
                  onChange={(value) => handleInputChange('enforcePasswordHistory', value)}
                  options={['2 passwords remembered', '3 passwords remembered', '4 passwords remembered']}
                  className="w-full mt-2"
                />
              </div>
            </div>

            <div className="flex items-start gap-8">
              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Minimum password length</label>
                <input
                  type="number"
                  value={formData.minimumPasswordLength}
                  onChange={(e) => handleInputChange('minimumPasswordLength', e.target.value)}
                  className="w-full mt-2 bg-[#232323]  rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Password Complexity</label>
                <Select
                  value={formData.passwordComplexity}
                  onChange={(value) => handleInputChange('passwordComplexity', value)}
                  options={[
                    'Include special characters, alphabets, numbers',
                    'Include alphabets and numbers only',
                    'Include special characters and numbers only'
                  ]}
                  className="w-full mt-2"
                />
              </div>
            </div>

            <div className="flex items-start gap-8">
              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Maximum invalid login attempts</label>
                <input
                  type="number"
                  value={formData.maxInvalidLoginAttempts}
                  onChange={(e) => handleInputChange('maxInvalidLoginAttempts', e.target.value)}
                  className="w-full mt-2 bg-[#232323]  rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="w-1/3">
                <label className="block text-sm text-gray-300">Lockout effective period(mins)</label>
                <input
                  type="number"
                  value={formData.lockoutEffectivePeriod}
                  onChange={(e) => handleInputChange('lockoutEffectivePeriod', e.target.value)}
                  className="w-full mt-2 bg-[#232323]  rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        </div>

        {/* General Section */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-white mb-6">General</h2>
          <div className="w-1/3 bg-[#2A2A2A] rounded-lg p-6">
            <label className="block text-sm text-gray-300">Cancel subscription user if payment fails</label>
            <Select
              value={formData.cancelSubscriptionAfter}
              onChange={(value) => handleInputChange('cancelSubscriptionAfter', value)}
              options={['3 times', '4 times', '5 times']}
              className="w-full mt-2"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-8">
          <button
            type="button"
            className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[140px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex items-cente justify-center gap-2 px-4 py-2 w-[140px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default Policies; 